import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form, Popover, } from 'antd';
import { useSession } from 'components/Authenticated';
import { saveInputHistory } from 'api/user-api';
import DropdownForm from './DropdownForm';
import styles from './style.module.less';
import InputWithHistory from './InputWithHistory';
const isSearchEmpty = (searchParams) => {
    const { all, projectname, transcription, speakers, notes, inAnyField, } = searchParams;
    return [all, projectname, transcription, speakers, notes, inAnyField].every((item) => item === '');
};
const FulltextSearchBar = ({ searchParams, onSearchChanged }) => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [form] = Form.useForm();
    const { session, updateUserSettings } = useSession();
    const { login: { user: { settings: { fulltextSearchParams } } } } = session;
    const EMPTY_FORM_VALUES = {
        all: '', projectname: '', transcription: '', speakers: '', notes: '', inAnyField: '', strict: fulltextSearchParams.strict,
    };
    const HISTORY_INPUT_IDS = ['projectname', 'transcription', 'speakers', 'notes', 'all', 'inAnyField'];
    useEffect(() => {
        form.setFieldsValue(searchParams === undefined
            ? EMPTY_FORM_VALUES
            : searchParams);
    }, [searchParams]);
    const saveSearch = async (searchFormValues) => {
        await Promise.all(HISTORY_INPUT_IDS.map((category) => {
            if (searchFormValues[category] !== '') {
                return saveInputHistory(session.connection, category, searchFormValues[category]);
            }
            return Promise.resolve();
        }));
    };
    const handleSearch = () => {
        const searchFormValues = form.getFieldsValue();
        const isStrict = form.getFieldValue('strict');
        if (isStrict !== fulltextSearchParams.strict) {
            updateUserSettings({
                fulltextSearchParams: {
                    strict: searchFormValues.strict,
                },
            });
        }
        if (isSearchEmpty(searchFormValues)) {
            onSearchChanged();
        }
        else {
            onSearchChanged(searchFormValues);
        }
        void saveSearch(searchFormValues);
        form.resetFields();
        setPopoverVisible(false);
    };
    const handleChangeAll = (values) => {
        if (values.all !== undefined) {
            form.setFieldsValue({ inAnyField: values.all });
        }
        if (values.inAnyField !== undefined) {
            form.setFieldsValue({ all: values.inAnyField });
        }
    };
    const handlePopoverVisible = (visible) => {
        setPopoverVisible(visible);
        if (!visible) {
            form.resetFields();
        }
    };
    return (_jsx("div", { className: styles.fulltextSearch, children: _jsxs(Form, { form: form, initialValues: EMPTY_FORM_VALUES, onValuesChange: handleChangeAll, children: [_jsx(Form.Item, { name: "all", children: _jsx(InputWithHistory, { inputId: "all", isSearchInput: true, onSearch: handleSearch, onPopoverVisible: () => setPopoverVisible(!popoverVisible) }) }), _jsx(Popover, { trigger: ['click'], content: (_jsx(DropdownForm, { onSearch: handleSearch, onPopoverVisible: (visible) => handlePopoverVisible(visible) })), open: popoverVisible, 
                    // @ts-ignore - popover supports forceRender, but it is missing in types
                    forceRender // without forceRender form values are undefined if popover is not open
                    : true, placement: "bottomRight", arrow: false })] }) }));
};
export default FulltextSearchBar;
